module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_xl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f00xl-01.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0001-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dietrich Boschung")])])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "part01"
    }
  }, [_c('h2', {
    staticClass: "part_num"
  }, [_vm._v("I")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('h2', {
    staticClass: "part_title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ICONOGRAPHIC SOURCES FOR THE ROMAN MILITARY")])])])])])]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section",
    attrs: {
      "id": "ch01sec1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num_hangs"
  }, [_vm._v("1.")]), _vm._v(" Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The numerous representations of the Roman military mainly fall into two categories: Roman funerary art, where soldiers are depicted on their gravestones, and state reliefs. They were not produced as an end in themselves, nor were they created with the intention of faithfully illustrating the structure or equipment of the Roman army, but for other reasons: with gravestones, a representative moment was always chosen, showing the depicted with his equipment to the best advantage."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_1",
      "id": "ch1_1"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("1")])]), _vm._v(" With state reliefs, the main purpose of the representations was to display the model behaviour of the exemplary commander in charge, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("i.e.")]), _vm._v(" the emperor. Among his main tasks was the provision of appropriate equipment for the soldiers, and especially the leadership of the army. Even if the emperor was not personally involved, he was ultimately responsible as holder of the auspices. The abundance of iconographic sources does not allow a comprehensive treatment of the subject here. Instead, I have restricted myself to a few, particularly informative, monuments. From these, it will become clear that there is no homogeneous convention for the representation of military themes in Roman art.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section",
    attrs: {
      "id": "ch01sec2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num_hangs"
  }, [_vm._v("2.")]), _vm._v(" Republican representations")])]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch01sec2_1"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The frieze on the monument of L. Aemilius Paullus at Delphi")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("By the end of the 19th century, Théophile Homolle had already recognized the association of a four-sided frieze from the sanctuary of Apollo at Delphi with the pillar monument of L. Aemilius Paullus, mentioned in several literary sources, and, as the subject of the representation, the battle between Macedonians and Romans at Pydna (168 BC)."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_2",
      "id": "ch1_2"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("2")])]), _vm._v(" Further research has followed him in this,"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_3",
      "id": "ch1_3"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("3")])]), _vm._v(" although some points are still very unclear. It seems the monument was initially started for the Macedonian king Perseus, the Roman "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("imperator")]), _vm._v(" then appropriating the monument as booty after his victory."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_4",
      "id": "ch1_4"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The subject of the frieze has been repeatedly associated with individual episodes of the Battle of Pydna,"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_5",
      "id": "ch1_5"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("5")])]), _vm._v(" which is described in Livy and Plutarch. Homolle interpreted the striking representation of a fleeing horse without a bridle, occupying the middle of the long side ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig12"
    }
  }, [_vm._v("Fig. 12")]), _vm._v("), with the help of literary information about the onset of battle."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_6",
      "id": "ch1_6"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("6")])]), _vm._v(" However, ownerless horses in flight are also common "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("in mythological battle scenes, such as Amazonomachy representations from the 5th century BC through to the Roman Imperial period."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_7",
      "id": "ch1_7"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("7")])]), _vm._v(" At the same time, in contrast to the frieze in Delphi, the animal is usually associated with a fallen rider figure in these depictions and provided with a bridle. The motif of the riderless horse is thus presented in a different manner on the Paullus frieze and must be of particular importance, as has often been emphasized."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_8",
      "id": "ch1_8"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0002-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig12"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 12")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0002-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig13"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 13")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0002-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig14"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 14")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0002-04.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig15"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 15")])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig12a"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 12–15")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Delphi, frieze from the pillar monument of Aemilius Paulus. "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig12"
    }
  }, [_vm._v("Figures 12")]), _vm._v("–"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig13"
    }
  }, [_vm._v("13")]), _vm._v(": eastern frieze; "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig14"
    }
  }, [_vm._v("Figure 14")]), _vm._v(": southern frieze (detail); "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig15"
    }
  }, [_vm._v("Figure 15")]), _vm._v(": western frieze (detail). Images: Cologne Digital Archaeology Laboratory")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other attempts to restore historically attested episodes of the combat in the frieze have been abandoned, however."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_9",
      "id": "ch1_9"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("9")])]), _vm._v(" Like the ownerless fleeing horse, some of the other figures also comply with the iconographic repertoire of mythological representations. These include horses with saddle blankets made from the fur of a predator (panther, lion), collapsed horses, and fallen mounts holding themselves upright with their front legs."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_10",
      "id": "ch1_10"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("10")])]), _vm._v(" The pose of a dying youth, with his head hanging back, crossed legs, and arm falling across his face, also corresponds closely with a traditional representational scheme in Greek art and is similar to the late classical theme of the dying children of Niobe."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_11",
      "id": "ch1_11"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Given the traditional character types used, it is all the more striking that the warrior figures have contemporary armament. The frieze is supposed to represent an actual event, but uses preset iconographic elements for this, which are reassembled according to its intent. Topical references, especially the characteristic shields, identify the two sides here. Three round shields are depicted as Macedonian by their decoration of concentric circles and semicircles (Liampi 1998). They are consistently assigned to the losing side: the first shield is carried by a foot "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("soldier standing behind a fallen rider and attacked by two Roman riders; a second soldier with a Macedonian shield is already forced onto his knee under the onslaught of the Romans ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig13"
    }
  }, [_vm._v("Fig. 13")]), _vm._v("); and the third Macedonian shield covers a dead man ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig14"
    }
  }, [_vm._v("Fig. 14")]), _vm._v("). The Macedonian troops are therefore hopelessly inferior in all phases of the fight. The shield of a fallen warrior is recognizable by its shape and distinct curvature as Macedonian. Only one Macedonian foot soldier is seen fighting, but showing his shield from the inside, so the decor is not visible. However, all the soldiers shown with the Roman "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("scutum")]), _vm._v(" (oval shield) are attacking or fighting ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig15"
    }
  }, [_vm._v("Fig. 15")]), _vm._v("). In four places on the frieze, they are to be found in the immediate vicinity of a falling or dead opponent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Neither the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("scutum")]), _vm._v(" nor the ‘Macedonian shield’ have been exclusively carried by a single nation. In many cases, the Etruscans and Celts used the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("scutum")]), _vm._v(", but the precise form used here is repeatedly found as the shield of Roman legionaries."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_12",
      "id": "ch1_12"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("12")])]), _vm._v(" Since they are also shown on Roman coins of the 3rd century BC and can be seen on the depiction of a trophy on the coins of Pyrrhus, these defensive weapons seem to have been regarded by both the Romans themselves and by their Hellenistic opponents as typical for the soldiers of Rome."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_13",
      "id": "ch1_13"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("13")])]), _vm._v(" On the Aemilius Paullus monument, the consistent distribution of the two shield forms, taken together with the inscription, suffice to characterize the triumphant side as Romans and the defeated as Macedonians.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The dramatic scenes of the Battle of Pydna reported by Plutarch and Livy are not recognizable in the representation on the frieze. Even the active role of the Macedonian cavalry there is in contrast to the historical accounts, whereby Perseus almost withdrew with the cavalry without engaging. The frieze avoids any hint of the menacing Macedonian phalanx, which had temporarily placed the Romans in serious difficulties. The elephants, whose attack initiated the Macedonian defeat,"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_14",
      "id": "ch1_14"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("14")])]), _vm._v(" are also not included in the frieze. Only the fleeing horse, whose depiction is striking in its isolation and not motivated by later events, can be understood as a reference to the initiation of the battle. This can hardly be accidental because, according to the oracles, the manner in which the battle came about meant that the victory of the Romans was preordained by the gods."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_15",
      "id": "ch1_15"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("15")])]), _vm._v(" The frieze shows only a hint of units in close combat on this long side; the two adjacent sides indicate a melee with a more vigorous mixing of the parties. This can be reconciled with the historical accounts, whereby the breakup of the Macedonian phalanx was crucial to the outcome of the battle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Above the inscription, the front of the frieze depicted the defeat of Perseus, heavily abbreviated:"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_16",
      "id": "ch1_16"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("16")])]), _vm._v(" a Roman horseman and a Roman legionary storm over a dead man, clearly indicated as a Macedonian by his shield, in pursuit of fleeing enemies ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig14"
    }
  }, [_vm._v("Fig. 14")]), _vm._v("). If the viewer followed the frieze to the adjacent sides and to the back, they could see how the defeat had occurred and that the Romans had started the fight in accordance with the omens. At no point in the battle are the Macedonian soldiers the equals of the Romans.")]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch01sec2_2"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Census Relief in the Louvre")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("In an entirely different context and in a different way, Roman soldiers appear on the Census Relief from Rome in Paris, dating back to the first half of the 1st century BC."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_17",
      "id": "ch1_17"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("17")])]), _vm._v(" It is divided into three sections, accentuated by the composition, the middle one of which occupies the most space ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig16"
    }
  }, [_vm._v("Fig. 16")]), _vm._v("). It shows a figure-rich sacrificial scene, in which a rectangular altar is the centre of the action. Next to it, on the left and facing the front, a beardless warrior with helmet and armour holds a spear with his raised right hand and rests his left forearm on a round shield, while his hand grasps the hilt of a sword. His head is turned to the altar, with his right foot resting on its base. Neither the shield nor the armour correspond to contemporary forms of weaponry, so it must be a mythological figure who is accepting the sacrifice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the other side, a man is wearing a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("toga")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("capite velato")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("i.e.")]), _vm._v(" pulled up over the back of his head, as was appropriate for the Roman ritual of sacrifice. His right hand holds a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("patera")]), _vm._v(" above the sacrificial face of the altar, over which an assistant is pouring wine. This is in preparation for a libation, which belongs to the bloodless part of the sacrificial ritual. Two musicians are also playing as part of the sacrificial ritual, a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kithara")]), _vm._v(" player and an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aula")]), _vm._v(" piper, who stand behind the armed deity and two smaller assistants, who assist the sacrificing togate figure and one of whom holds an incense box on his left shoulder. From the left, the sacrificial animals – a bull, a sheep, and a pig – are led to the altar after the preparatory offerings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this main scene, two brief depictions are connected to the left and right. That on the left shows two groups of two, each comprising a standing and a sitting togate figure ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig17"
    }
  }, [_vm._v("Fig. 17")]), _vm._v("). The man sitting on the left end of the frieze rests a large unfolded writing tablet on his knees, upon which he makes an entry with his pen. The standing figure looks on and gestures towards the tablet, while he holds a smaller, closed writing tablet to his chest. In the second group, the seated figure turns to the standing man and touches him on the shoulder while he places his right hand in front of his chest in a gesture of oath-taking. Between this group and the sacrifice scene, two soldiers with helmet, mail, sword, and oval shield are standing, one of whom looks towards the oath scene, the other at the sacrifice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the right-hand side of the frieze, three more soldiers with helmet, mail, and sword can be seen ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig18"
    }
  }, [_vm._v("Fig. 18")]), _vm._v("). Two of them, who also carry a large oval shield, turn towards each other and are deep in conversation; "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("the third takes care of his horse. Even in 1841, the French archaeologist Clarac had realized that the frieze depicts scenes from a Roman census (Clarac 1841); this interpretation is not disputed. The census happened on the Campus Martius – a site outside the city of Rome – and was initially held every five years by two censors (Kubitschek 1899). Every mature Roman citizen had to appear before the censors and, under oath, account for his family and financial circumstances. He was then assigned to one of five tax brackets, according to his assets, and to a voting constituency. This was accompanied by a military muster, whereby citizens had to present themselves and their weapons. In addition, this was combined with a review of the Senate and the equestrians. A violation of the existing moral codes by these gentlemen could be punished with different penalties: admonitions or reprimands, but also reductions in status by transfer to a lower class or by exclusion from senatorial or equestrian rank. The censors were also responsible for the control of the management of public assets and tax revenue. As assistants to the censor, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("iuratores")]), _vm._v(" (oath swearers) are found recording assets. The conclusion of the census was the sacrifice of purification ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lustrum")]), _vm._v(") for Mars, in which the entire army took part, and which ensured that the census was valid. Lots were drawn for which of the two censors would perform the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lustrum")]), _vm._v(". Finally the censors led the people back to the city.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0004-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig16"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 16")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0004-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig17"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 17")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0004-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig18"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 18")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig_caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 16–18")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paris, Louvre. Census Monument. Images: Cologne Digital Archaeology Laboratory")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The scene on the left side of the frieze therefore represents the actual census ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig17"
    }
  }, [_vm._v("Fig. 17")]), _vm._v("): the seated scribe is in the process of entering the details of the citizen in front of him in the master list of citizens; the citizen in turn has brought a diptych in order to prove his status. The next group of two shows a standing citizen swearing his details to a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("iurator")]), _vm._v(". The soldiers, who are represented at two points on the reliefs, are illustrating the military aspects of the census. They take no special part in the action; they talk to each other and take "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("care of their weapons and their horses ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig17"
    }
  }, [_vm._v("Fig. 17")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig18"
    }
  }, [_vm._v("18")]), _vm._v("). They are not lined up in formation, but stand there at ease and thereby show their equipment to advantage. They have not been summoned to fight, but to muster.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the centre is the lustration (Saladino 2004). It is offered to Mars by the censor chosen by lot and it is a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("suovetaurilia")]), _vm._v(", or the sacrifice of a pig, sheep, and bull. Here, the censor vowed a new victim for Mars if he would protect the people until the next lustration. The representation thus emphasizes the sacred side of the census and various aspects of the ritual. The censor at the altar has pulled the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("toga")]), _vm._v(" over the back of his head and thus complies with the requirements for a sacrifice according to Roman ritual. Other rules are also strictly adhered to: a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("camillus")]), _vm._v(" pours wine into the sacrificial bowl; another is holding incense ready; musicians accompany the sacrifice with their playing; the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hostiae")]), _vm._v(" (sacrificial animals) for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("suovetaurilia")]), _vm._v(" are all male and fully grown; they are – as was required for a favourable sacrifice – willingly led to the sacrificial location. The dramatic moment of the killing, in which the censor would have played only a minor role, is not shown; instead, the bloodless preliminary sacrifice is chosen, in which he is central. While the sacrificial personnel are shown in detail, the celebrants, however, are completely absent. The soldiers, casually turned away, are certainly not intended as participants. They illustrate the military aspect of the census, whereby the Roman army was formed by the muster and classification, and at the same time purified by means of the final lustration ritual.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In antiquity, the census frieze was associated with a three-panel mythological relief depicting the wedding of Poseidon and Amphitrite."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_18",
      "id": "ch1_18"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("18")])]), _vm._v(" This relief differs not only thematically but also stylistically from the census relief and was probably only connected to it in a secondary use in Rome. Together, the friezes decorated the base of a large monument, perhaps a statue group. Here, the mythological part can be understood as a symbol for the mastery of the seas and thus also as a euphemism for a naval victory. If the antiquarian and iconographic studies of the census frieze suggest an origin in the first half of the 1st century BC, the exact dating of the monument and its attribution to a historical personality are as yet still controversial. The most likely connection is with the censors of the year 70 BC – L. Gellius Poplicola and C. Cornelius Lentulus Clodianus – who performed the first census after an interruption under Sulla. At that time, 64 senators were excluded from the Senate (Livy "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("per")]), _vm._v(". 98), illustrating how the census could be exploited in the context of domestic political conflicts. However, the relief does not depict exceptional moments, which could appear as politically motivated and therefore problematic; rather, it offers an idealized image of a census, by emphasizing the religious aspects.")]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch01sec2_3"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Sant’Omobono base (Bocchus Monument)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Different military aspects are addressed on the so-called Bocchus Monument from the Sullan period, in other words from the first decades of the 1st century BC."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_19",
      "id": "ch1_19"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("19")])]), _vm._v(" Fragments of a large frieze of grey limestone survive which served as panels covering four sides around a large base. The find spot in Rome suggests that it was originally set up at the Temple of Fides on the Capitol.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The centre of the front is occupied by a large round shield, to which archaically stylized personifications of Victory are attaching a laurel garland; the scene is flanked by large candelabra ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig19"
    }
  }, [_vm._v("Fig. 19")]), _vm._v("). The relief decoration of the shield shows two flying cupids, bearing an empty inscription panel, and under them an eagle sitting on a thunderbolt. It has outspread wings and holds a palm branch, which has two wreaths and a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("taenia")]), _vm._v(" wound round it. To the right of this depiction is a block presenting an array of different weapons ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig20"
    }
  }, [_vm._v("Fig. 20")]), _vm._v("): first a greave with a frontally viewed head of Hercules on the knee and an extremely animated Victoria below; then an undecorated muscle cuirass; a round shield with a representation of one of the Dioscuri riding a horse; and finally a chamfron. The left third of the front face can be reconstructed as a mirror image to this, as demonstrated by a surviving fragment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The right side ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig21"
    }
  }, [_vm._v("Fig. 21")]), _vm._v(") is also structured symmetrically and here a relief-decorated round shield is likewise central, in this case with the helmeted head of a goddess, who can be seen as Roma, Minerva, or Virtus. The shield is flanked by two "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tropaia")]), _vm._v(", each hung with a helmet and a cuirass. The neighbouring side is balanced to the left and right with the depiction of a cuirass, which is adorned with a gorgon on the breast, with a hovering Victoria on each of the epaulettes. Another fragment, from the rear face, represents a rectangular shield with curved sides, its relief decoration depicting a winged serpent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What is striking is the stylized nature of the representation: the weapons and items are not shown in their functional context, but are lined up, without taking into account any change in proportions: candelabra, trophy, round shield, greaves, and breastplate are all adapted to the height of the frieze and are thus approximately equal in height. The stylized arrangement of the objects is in turn matched by the decoration, with mirror symmetry as the dominant principle controlling the overall presentation. This distinguishes the ‘Bocchus monument’ from the Pergamum weapons friezes, where the irregularity of the arrangement symbolizes the random accumulation of enemy booty captured."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_20",
      "id": "ch1_20"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("20")])]), _vm._v(" There are Hellenistic precursors for a symmetrical arrangement of weaponry as well. The paintings in the Macedonian tomb of Lysias and Callicles "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("in Lefkadia (created "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("c")]), _vm._v(".200 BC) show weapons hanging on the wall, including ‘Macedonian’ shields."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_21",
      "id": "ch1_21"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("21")])]), _vm._v(" However, the symmetrical composition adopted is simpler and more uniform: for instance the lack of a similar combination of victories, candelabra, and trophies. In the Sullan frieze, however, the weapon representations are highly charged with symbolic references and combined with additional elements. Overlaps and moving figures result in a visual accumulation that could be understood as action only in the middle of the front face ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig19"
    }
  }, [_vm._v("Fig. 19")]), _vm._v("). However, the ‘acting’ victories stand like statues on their own pedestals and they are shown in archaic, hieratic formal language. The cupids ‘acting’ similarly and the moving eagle are already part of the shield adornment.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0006-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig19"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 19")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0006-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig20"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 20")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0006-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig21"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 21")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig_caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 19–21")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rome, Capitoline Museums. Base of San Omobono (‘Bocchus monument’)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The individual symbols are not difficult to understand in themselves: weapons, trophies, and palm branches point to military successes, while the candelabra are sacrificial equipment within the sacred realm. In figural representations, Victoria is most strongly emphasized as a goddess of victory, reinforcing the already obvious military references in the frieze. She is shown in three different forms: on the epaulettes of the cuirass to one side, she floats down to bestow (or report) a victory. On the front of a greave, she runs up, armed, appearing as a comrade-in-arms, actively bringing about the victory that she personifies. On the centre front, the goddess of victory occurs twice, symmetrically. The archaic formulas of the symmetrical, artistically drawn folds of drapery and stiff, upstanding curls are to be understood as denoting age and respectability. These figures of Victoria contrast conspicuously with other representations of the goddess of victory, appearing as venerable divinities who, although shown like statues, are also endorsing the shield of the victor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Dioscuri, Roma (or Minerva?), and Hercules are only indirectly evoked in the decoration of weaponry. They were the tried and trusted tutelary deities of the Romans and helpers in time of war. The eagle on the thunderbolt refers symbolically to Jupiter, the supreme god of Rome, the cupids to Venus, which in this strongly militarily influenced context is not at first readily understandable. The decoration of the weaponry makes it clear that it is not looted weapons that are being shown here, but rather the carefully maintained and preserved ceremonial weapons of the Roman victors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The frieze has been dated to the time of Sulla with good arguments, some of them stylistic. T. Hölscher has proposed its identification with an historically attested monument which King Bocchus of Mauritania erected in honour of Sulla in 91 BC and whose sculptural group represented the surrender of Jugurtha."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_22",
      "id": "ch1_22"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("22")])]), _vm._v(" Although the identification of the monument is not without problems,"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_23",
      "id": "ch1_23"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("23")])]), _vm._v(" the connection with Sulla would explain the allusion to Venus in such a prominent place: she was the patron goddess of Sulla, whose Roman epithet Felix was translated in Greek as Epaphroditus. The reliefs do not provide a specific narrative: rather, they depict a series of symbolic groups and individual emblematic designs that are presented alongside each other and partly have no discernible direct relationship. These individual motifs add up to an overall statement: they recall the tutelary gods of Rome and especially the "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("patroness of Sulla, even if only indirectly through the shield design; and they evoke military successes through figures and attributes and elevate them to a sacred level by simultaneously combining them with the two candelabra. The historical events to which the reliefs allude, and which were perhaps explained in a corresponding inscription, are not even shown; the victorious quality of the commander is not limited to a particular situation, but is independent of specific operations. The person being honoured is indeed absent, but at the same time all the elements in it indicate him as the true focus. Perhaps he appeared prominently in the sculptural group on top of the base. The statement being made by the relief must have been evident to the ancient viewer through the overall context ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("i.e.")]), _vm._v(" in relation to site, inscription, and sculpture).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These three examples – the Aemilius Paullus monument, the census relief, and the ‘Bocchus Monument’ – do not allow any fixed representational conventions for military issues to be identified for the period of the Roman Republic. Rather, they vary according to the occasion and original context. It is always about the glory of a single person; neither the Roman people, the Senate, nor the army are guarantors of success or the agents of historical developments; instead this is always an outstanding individual. His performance could be equally well illustrated by a narrative representation as by a stereotypical scene or a symbolic description. These different modes of representation existed simultaneously and side by side. They all exploit the Hellenistic Greek repertoire, but in different ways. Thus the frieze on the Aemilius Paullus monument employed single figure types from Hellenistic mythological friezes and updated them with contemporary armament. The ‘Bocchus Monument’ extended Hellenistic stereotypes and charged them with a wealth of symbolism.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0007-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig22"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 22")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rome, Capitoline Museums. Frieze block with ship components and sacrificial equipment")])])]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section",
    attrs: {
      "id": "ch01sec3"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num_hangs"
  }, [_vm._v("3")]), _vm._v(" The Early Empire: Augustus to Domitian")])]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch01sec3_1"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The frieze from the Porticus Octaviae")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("A frieze from the Porticus Octaviae in Rome is formally connected to the representation of the ‘Bocchus Monument’,"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_24",
      "id": "ch1_24"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("24")])]), _vm._v(" reproducing equipment in a symmetrical arrangement and without regard to the actual proportions. At the same time, the compositional scheme is further developed in a way that is characteristic of the Augustan period. The frieze was divided into equal panels by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bucrania")]), _vm._v(", some of which show the components of ships ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig22"
    }
  }, [_vm._v("Fig. 22")]), _vm._v("). The objects are repeated: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cheniskos")]), _vm._v(" (bow fitting) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("prora")]), _vm._v(" with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("rostrum")]), _vm._v(" (prow with battering ram) occur in the frieze (only partially preserved) five times; anchor, rudder and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aplustre")]), _vm._v(" (stern adornments) occur four times. So those decorative and symbolic parts of warships are shown on the frieze that had long been seen as a sign of victorious sea battles. However, the ship parts are not simply piled up, but instead they are rather artfully composed, with the symmetrical arrangement emphasizing the aesthetic standards of presentation. The central axis of this relief of ship trophies, strangely enough, is taken up with a sacrificial accessory, namely a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("turibulum")]), _vm._v(" (incense stand).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In fact, the sections with ship components alternate regularly with a second theme, namely that of images of sacred devices."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_25",
      "id": "ch1_25"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("25")])]), _vm._v(" They show instruments that would complement each other functionally in the course of a sacrificial ritual: the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aspergillum")]), _vm._v(" (holy water sprinkler) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mappa")]), _vm._v(" (towel) were used in ritual purifications; the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("acerra")]), _vm._v(" (incense box) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("turibulum")]), _vm._v(" (incense stand) with incense; the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("simpulum")]), _vm._v(" (ladle), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("urceus")]), _vm._v(" (wine jug) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("patera")]), _vm._v(" (offering dish) with the libation; and the axe and dagger with animal blood sacrifices. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("galerus")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("(leather cap) was a significant part of the costume of the high priest. Some of these sacrificial devices are to be understood as badges of priesthood:"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_26",
      "id": "ch1_26"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("26")])]), _vm._v(" the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("simpulum")]), _vm._v(" can stand for the priesthood of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pontifices")]), _vm._v("; the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lituus")]), _vm._v(" for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("augures")]), _vm._v("; the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("galerus")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("apex")]), _vm._v(" for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("salii")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("flamines")]), _vm._v("; and the laurel on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("acerra")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("urceus")]), _vm._v(" can be seen as indicative of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quindecemviri sacris faciundis")]), _vm._v(" (‘fifteen men for the procurement of victims’), one of the four highest colleges of priests. The frieze sections with sacred devices were also symmetrical in respect to the central axis of the ship reliefs to which they are connected. Military success and piety are inextricably interlinked in this frieze; they change constantly over the course of the frieze, but the different portions are always of the same size and thus equivalent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So the frieze alludes to and interprets historical events without really representing them. The ship components displayed give no indication of the defeated enemy, the occasion of the battle, or the identity of the victor. Depicting the sea battles of Naulochos and Actium would also have been problematic because it would need to show Romans fighting against Romans. In addition, the role of Octavian in the two battles had not exactly been heroic: in the Battle of Naulochos, he is supposed to have lain petrified, flat on his back, and only got up again when Agrippa had won the battle for him (Suetonius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Augustus")]), _vm._v(" 16.1–2). These difficulties have been solved by omitting the actual event: the reliefs do not depict a particular event, but formulate a general statement – the connection between "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pietas")]), _vm._v(" (piety) and victory. The multiple changes and the compositional logic of the representations show that piety and political success are forever linked. It is therefore a particularly striking reference when a sacrificial device appears in the centre of the section with ship trophies and points to the common axis of symmetry. And since traditional "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pietas")]), _vm._v(" was restored by Augustus (the attributes of the priesthood, which Augustus had reformed, demonstrate this), political and military successes inevitably appear. The victory of Augustus was not the result of blind chance, which might lead to a very different result next time; rather it was the logical, compelling result of the religious policy of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("princeps")]), _vm._v(". The victorious general himself does not appear in all this.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the Porticus Octaviae was named after the sister of Augustus, it was actually financed by Octavian from the spoils of the Dalmatian War (Cassius Dio 49.43.8; Suetonius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Augustus")]), _vm._v(" 29.4). The frieze thus provides an authentic vision of Octavian, or was at least authorized by him. This view is reflected in the speech that Octavian is supposed to have addressed to his troops before the battle of Actium (Cassius Dio 50.24): in effect, righteousness and piety lead to victory. The Augustan view, that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pietas")]), _vm._v(" and military success were necessarily related, differed fundamentally from the point of view of some late republican generals: Lutatius Catulus credited "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fortuna huiusce diei")]), _vm._v(", the goddess of fortune of the present day, for his victory over the Cimbri in 101 BC (Plutarch: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marius")]), _vm._v(" 26.2). In this view, warfare appeared to be a kind of game of chance, success depending upon the ever-changing constellations. The frieze in the Porticus Octaviae proclaimed that this risky state of affairs had been overcome by Augustus.")]), _vm._v(" "), _c('h4', {
    staticClass: "sub_leveld",
    attrs: {
      "id": "ch01sec3_2"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The silver cup from Boscoreale")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("While the monuments of the later Augustan period concentrated upon military successes, military events were almost completely suppressed. A significant example of this is demonstrated by two silver "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("skyphoi")]), _vm._v(" from Boscoreale,"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_27",
      "id": "ch1_27"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("27")])]), _vm._v(" one of which shows Augustus as the main character of the two relief representations, the other Tiberius. T. Hölscher has pointed out that they show the Roman campaign of the year 8/7 BC in Germania. Tiberius had at that point defeated the Germans between the Rhine and the Elbe and celebrated a triumph in Rome in 7 BC. In 8 BC, Augustus himself was near the combat zone, but remained on the left bank of the Rhine, while Tiberius crossed it (Cassius Dio 55.6; Velleius Paterculus 2.97.1).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Tiberius cup shows the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vota nuncupata")]), _vm._v(", the sacrifice upon Tiberius’ departure at the beginning of the campaign on one side ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig23"
    }
  }, [_vm._v("Fig. 23")]), _vm._v(")."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_28",
      "id": "ch1_28"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("28")])]), _vm._v(" The process of the bull sacrifice is shown in detail, with the victim held in the correct manner by well-trained staff. By including the temple facade, with its gable ornaments, the location of the event is suggested: the eagle on the pediment shows that the sacrifice takes place in front of a Temple of Jupiter, which stands on a high podium. The front of the temple is divided by four columns into three sections. It is tempting to see in this sacred building the Temple of Jupiter Optimus Maximus, which contained the three "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cellae")]), _vm._v(" of the Capitoline Triad."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_29",
      "id": "ch1_29"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("29")])]), _vm._v(" The image on the opposite side ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig24"
    }
  }, [_vm._v("Fig. 24")]), _vm._v(") represents the triumph of Tiberius. Despite their small size, the attributes of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("triumphator")]), _vm._v(" are depicted very accurately: the eagle sceptre; the laurel branch in his right hand; the crown which is held over his head by a slave; his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("toga")]), _vm._v("; and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quadriga")]), _vm._v(" with its ornate coachwork. In front is a bull that, from its decoration, is shown to be a sacrificial animal, anticipating the sacrifice that will take place at the conclusion of the triumphant procession to the Capitol.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the Augustus cup, one scene shows the submission of a barbarian tribe before Augustus ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig25"
    }
  }, [_vm._v("Fig. 25")]), _vm._v("). The emperor sits on a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sella castrensis")]), _vm._v(", but is otherwise pictured in a pointedly civilian manner. He has a large crowd of escorts closely surrounding him, indicating his importance: the lictors with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fasces")]), _vm._v(" mark him as a high curule magistrate; the standing staff officers make clear "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("the role of the emperor as supreme commander, but they are held at a distance by Augustus’ lictors. The other side shows Augustus as a civilian official: sitting on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sella curulis")]), _vm._v(", in tunic and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("toga")]), _vm._v(", with a scroll in his left hand. But here he appears frontally, like a cult image, and isolated within an empty space. In his outstretched right hand he holds the globe, a symbol of world domination. Around him stand, at a reverent distance, goddesses and gods. Mars, the ancestor of the Romans, leads in a group of personified provinces from the right. From the left, Venus, the ancestress of the Julii, appears before the seated emperor, to place a Victoria statuette on his globe. Behind her are Honos and Virtus, the personifications of honour and martial prowess.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0009-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig23"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 23")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0009-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig24"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 24")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig_caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 23–24")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paris, Louvre. Tiberius cup from Boscoreale")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0009-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig25"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 25")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paris, Louvre. Augustus cup from Boscoreale")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The four reliefs of the cups just described provide, as is usual with early imperial "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("skyphos")]), _vm._v(" pairs, a complete sequence of images. They depict Augustus, upon whom the gods have bestowed victory, as ruler of the world. He receives the submission of the barbarians. His son Tiberius departs from Rome as a commander in the war and returns victorious, in triumph, to Rome. The actual military events are not shown. The campaign, which is the reason for the events depicted, remains obscure and is limited to the elaborate presentation of two religious rituals. As in the frieze of the Porticus Octaviae, piety and victory are also permanently and inextricably linked in this event.")]), _vm._v(" "), _c('h4', {
    staticClass: "sub_leveld",
    attrs: {
      "id": "ch01sec3_3"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Representations from the Julio-Claudian period")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Other monuments of the Augustan and Tiberian period show the same distribution of roles between the emperor and the imperial princes as on the Boscoreale cup. The Gemma Augustea,"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_30",
      "id": "ch1_30"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("30")])]), _vm._v(" referring to the military successes in the years AD 6–12, also portrays the victory and triumph of Tiberius, but in a different, panegyrical, formal manner ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig26"
    }
  }, [_vm._v("Fig. 26")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the lower frieze, Roman soldiers erect a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tropaion")]), _vm._v("; captives squat on the ground or are dragged in. Above, Tiberius, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tunica")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("toga")]), _vm._v(", crowned with laurel, dismounts from a four-horse chariot. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quadriga")]), _vm._v(", the costumes, and the wreaths match the characteristics of a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("triumphator")]), _vm._v(", recalling the success of Tiberius in AD 12. But here the triumph is not depicted realistically, but exaggerated panegyrically: Tiberius holds the long sceptre of the gods and Victoria, the goddess of victory, serves as his charioteer. Moreover, Germanicus – whom Tiberius had adopted in AD 4 as a young officer – stands next to the chariot. Roma and Augustus are sitting on a bench, the feet of the latter resting on captured weapons. Between their heads is a disc bearing two star signs, the Julian Star ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sidus Iulium")]), _vm._v(") that marked the deification of Caesar, and the capricorn, the zodiacal sign of the emperor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cameo shows the deification of Caesar the father as inevitably predetermining the reign of Augustus, guaranteed by the stars. The emperor is the main character of the cameo scene: all eyes are on him. Just like Jupiter, he sits topless, wearing only a cloak over his hips; like Jupiter, he holds the long sceptre of the gods. The eagle, the familiar of Jupiter, sits at his feet and looks up at him. Next to him, a group of gods are resting: Tellus, Oceanus, "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("and Oikumene (the personification of the inhabited earth), holding the oak wreath over his head. The striking attribute in the right hand of Augustus is a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lituus")]), _vm._v(", the attribute of the augurs. It here appears as a sign that it is Augustus holding the auspices for the campaign. For, as commander in chief, the leader of the empire took the auspices, predicting the course of a planned war. Again, the image gives no hint of the campaign, but illustrates the fortunate achievement of an ideal state of affairs. Again, the imperial family appears as the guarantor of Roman victory. Augustus, the pre-determined ruler of the world, supported by the gods, takes the auspices; Tiberius returns victorious in triumph; the young Germanicus is ready to provide active support as an officer. Three generations of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("domus Augusta")]), _vm._v(" ensure the continuity and durability of the Roman Empire.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig26"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 26")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vienna, Kunsthistorisches Museum. Gemma Augustea. Photo: Cologne Digital Archaeology Laboratory")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These roles survived the Augustan period and are also found on Tiberian monuments. The relief on the sword sheath of the so-called ‘Sword of Tiberius’"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_31",
      "id": "ch1_31"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("31")])]), _vm._v(" shows the encounter between the Emperor Tiberius and the commander Germanicus ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig27"
    }
  }, [_vm._v("Fig. 27")]), _vm._v("); Tiberius is enthroned between Mars and Victoria Augusta; Germanicus stands before him in armour and hands him a statuette of Victoria, the embodiment of his victories. Again, the roles are clear. No matter how proficient the commander might be, the "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("guarantor of victory was the Emperor himself. After the death of the younger Drusus (AD 23), Augustus’ succession policy was finally in tatters; however, its representation initially continued. This makes the images of the Grand Camée – created in the years AD 23–9 – significant."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_32",
      "id": "ch1_32"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("32")])]), _vm._v(" Again, the Emperor Tiberius is enthroned like Jupiter in the centre with the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aegis")]), _vm._v(" and also holding the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lituus")]), _vm._v(" here. The three sons of Germanicus stand around him in armour; they are sent out by the Emperor, doubtless to great deeds and victories. Of course, any specific reference is lacking here: there were no military undertakings by the princes to celebrate; at best one could hope that they would emulate the shining example of their father in the near future.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0011-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig27"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 27")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("London, British Museum. Decorated plate from a sword scabbard (‘Sword of Tiberius’)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0011-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig28"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 28")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Privately owned. Sesterce of Caligula (RIC)")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The monuments emphasize the responsibility of the emperor for the military and demonstrate that his person guaranteed victories. But at the same time they demonstrate the distance that separates the Jupiter-like emperor from the martial craft of the soldiers. While there are definitely representations of combat in the Augustan and Tiberian period ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("e.g.")]), _vm._v(" the Arch of Orange: Amy 1962), the emperor is never directly connected with them. This is important for two reasons. One was that the role of Augustus as a caudillo figurehead in the civil wars had not been forgotten. In addition, the personal bravery of Octavian was not without controversy. His opponents accused him of fleeing from the Battle of Mutina and only surfacing again after two days (Suetonius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Augustus")]), _vm._v(" 10.4); during the first Battle of Philippi he hid for three days in the marshes (Pliny, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Naturalis Historia")]), _vm._v(" 7.148); at Naulochos, he lay paralysed on his back and only got up once Agrippa had won the battle for him (Suetonius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Augustus")]), _vm._v(" 16.2). His portrayal as a great warrior might therefore have provoked opposition or at least undesirable associations. In contrast, the solution he chose made any comparison with living or dead war heroes impossible. This made clear that his position was incomparable and unique.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The representations of the following decades differ in some aspects from Augustan conventions for representation. From the time of Caligula, the attachment of the emperor to his soldiers is emphasized more strongly in official self-representation."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_33",
      "id": "ch1_33"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("33")])]), _vm._v(" A coin of Caligula with the inscription "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("adlocutio cohortum")]), _vm._v(" shows an address by the emperor to his soldiers ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig28"
    }
  }, [_vm._v("Fig. 28")]), _vm._v("): the emperor is in a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("toga")]), _vm._v(" in front of a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sella castrensis")]), _vm._v(". In his left hand he holds a scroll, while the right he raises to the soldiers in full armour (with helmet, shield, and sword) in front of his podium. They are standing in close formation and hold four standards, on each of which an eagle is perched. The round discs on the standards will have contained the imperial busts which they carried as an expression of loyalty to their emperor."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_34",
      "id": "ch1_34"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("34")])]), _vm._v(" The emperor himself appears unarmed and in civilian garb: he is not inclined to fight with his troops, but he leads them; and in return earns the loyalty of the soldiers. Two coins from the earliest part of the reign of Claudius refer to the strange circumstances of the beginnings of his government, when the Praetorians played a decisive role as king makers. The first bears the inscription "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("praetor(ianis in fidem) recept(us)")]), _vm._v(": the togate emperor stands opposite a Praetorian "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("signifer")]), _vm._v(", offering his hand. This gesture expresses solidarity, but also implies equality. The other coin, with the inscription "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Imper(ator) recept(us)")]), _vm._v(", shows the Praetorian camp, where the emperor had found refuge.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig29"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 29")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig30"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 30")])])]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch01sec3_4"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Cancelleria reliefs")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Despite these changes, a key element of the Augustan concept is still found at the end of the 1st century AD, namely in the Domitianic reliefs from the Cancelleria. They had already been placed into storage in antiquity, but they are likely to have been found close to their original location and to have belonged to a building on the Campus Martius in Rome. One of the two friezes, which certainly belong together,"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_35",
      "id": "ch1_35"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("35")])]), _vm._v(" originally showed the departure of the Emperor Domitian to war ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig29"
    }
  }, [_vm._v("Fig. 29")]), _vm._v("); after his assassination, his portrait was altered into a likeness of his successor Nerva. The emperor is placed as the principal figure in the centre of the work ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig30"
    }
  }, [_vm._v("Fig. 30")]), _vm._v("). He wears the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tunica")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("paludamentum")]), _vm._v(", faces left and is raising his hand towards the front, indicating the direction of the march. An armed woman in Amazon costume, representing Virtus (personified bravery), supports the emperor by grasping his left forearm. In front of him, Minerva and Mars are moving in the direction the emperor indicates, while simultaneously looking back at him. Minerva, the patron goddess of Domitian, is equipped for war with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aegis")]), _vm._v(", helmet, round shield, and spear. The bearded god of war, Mars, also has a helmet, shield, and spear, but with a muscled cuirass. His round shield, with a head of Ammon, is like the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("clipei")]), _vm._v(" adorning the Forum of Augustus, and therefore it may be that the avenging Mars Ultor was intended here. In front of Mars and behind the emperor walk the lictors, designating the rank of senior officials.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Behind Virtus, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("genius")]), _vm._v(" of the Senate and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("genius")]), _vm._v(" of the Roman people are standing. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("genius Senatus")]), _vm._v(" appears as a worthy bearded man with long hair and, like the senators, whose assembly he embodies, he wears "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tunica")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("toga")]), _vm._v(", and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("calcei patricii")]), _vm._v(". He holds a sceptre with the bust of the emperor and thus provides an expression of the close connection between ruler and Senate."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_36",
      "id": "ch1_36"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("36")])]), _vm._v(" The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("genius populi Romani")]), _vm._v(" appears as an idealized young man with long curly hair, wearing a cloak around his hips which leaves his upper body free, and with a cornucopia. Both have raised their right hands to the emperor. In contrast to the companions of the emperor, they remain in Rome, while the following soldiers set off to follow their emperor. On the extreme right of the frieze are three soldiers in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("paenula")]), _vm._v(" and travel clothing, but equipped with oval shield and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pilum")]), _vm._v(". The fourth figure preceding them has different equipment, carrying a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hasta")]), _vm._v(", like the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("principales")]), _vm._v(" (NCOs),"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_37",
      "id": "ch1_37"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("37")])]), _vm._v(" and a round shield he has not put on, but carries under his arm. This figure is the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("armiger")]), _vm._v(", the armour-bearer of the Emperor. The left end of the frieze is lost, but surviving traces show that a flying Victoria led the procession.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig31"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 31")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig_caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 29–31")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vatican, Museo Gregoriano Profano. The Cancelleria reliefs. Images: Cologne Digital Archaeology Laboratory")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thus, the relief shows the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("profectio")]), _vm._v(" of the ruler: he is leaving Rome with his soldiers on a military expedition, the victorious outcome of which is announced by the Victoria flying in front (alternatively, Hölscher 2009 sees an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("adventus")]), _vm._v(" here). The closest companions to the emperor are the gods Mars, Minerva, and Victoria. The Senate and people of Rome see him off in an appropriate manner. The emperor, as a high civil magistrate, is still travelling with his lictors, but he carries his weapons with him and, if necessary, would fight with his soldiers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The main figure in the second frieze (Frieze B: "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig31"
    }
  }, [_vm._v("Fig. 31")]), _vm._v(") was originally Domitian, but the portrait head was also subsequently changed, in this case to Vespasian. The emperor wears the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("toga")]), _vm._v(" and is turning to a second, youthful "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("togatus")]), _vm._v(". Behind these are the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("genius")]), _vm._v(" of the Roman people and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("genius")]), _vm._v(" of the Senate, who look towards the emperor. A flying Victoria (of which only one leg and a toe survive, because of the fragmentary state of the reliefs), hovering above, brings an oak wreath to set upon the ruler – the highest military decoration, only given for the rescue of a Roman citizen. Again, lictors surround the emperor. At the left-hand end of the frieze, perched on a pedestal, is the goddess Roma; like the Vestal Virgins standing in front of her, she looks toward the emperor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This frieze, complementing the first, shows the return of the emperor to Rome. Victorious, he is crowned by Victoria, welcomed into Rome by the Senate and people, and awaited by the Vestal Virgins and the city goddess. As with the Tiberius cup from Boscoreale, the victorious war is depicted by two rituals. However, here these are not religious acts indicating the relationship between "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pietas")]), _vm._v(" and victory and at the same time acting as a framework for military success. Rather, it is the solemn ceremonies of departure and return, expressing the close but at the same time hierarchical ties between the ruler on one hand and the priesthood, the Senate, and the people on the other. The Cancelleria reliefs combine representational conventions that occur simultaneously but separately in the Augustan period. They show – like the Gemma Augustea – personifications of gods as companions of the emperor, which elevate his person into the mythological realm. Like the Tiberius cup from Boscoreale, they strive for detail in recording reality, such as in the equipment and garb of the lictors or soldiers. These details make the representation plausible and thus validate the panegyric exaggeration. Again, however, the events of war are avoided, description being limited to the events in Rome itself. Thus it is not specified which of the wars of Domitian is intended. Possible confrontations are the wars against the Chatti (AD 83), the Dacians (AD 86–8), and the Sarmatians (AD 92), in all of which Domitian was personally present.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_sectiond",
    attrs: {
      "id": "ch01sec4"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num_hangs"
  }, [_vm._v("4")]), _vm._v(" Representations from the middle imperial period")])]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch01sec4_1"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Trajan’s Column")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The Trajanic period reveals a fundamentally different view of the military tasks of the emperor. It found its most impressive expression in the reliefs of Trajan’s Column."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_38",
      "id": "ch1_38"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("38")])]), _vm._v(" With a height of 100 ft, an internal spiral staircase illuminated by windows, and a helical frieze nearly 200 m long, it belongs to the grand architectural achievements of antiquity and, due to its near-complete state of preservation – only the crowning statue of the emperor has been lost – is one of the most important monuments of imperial Rome ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig32"
    }
  }, [_vm._v("Fig. 32")]), _vm._v("). The column was financed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ex manubiis")]), _vm._v(" – in other words, from the spoils of the Dacian Wars – and consecrated in AD 113. After the death of the Emperor Trajan, his ashes were buried in its base.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig32"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 32")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig33"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 33")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig34"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 34")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 155 scenes, the frieze depicts events from the two Dacian wars of Trajan in the years AD 101–2 and 105. These are partly standard combat scenes, but specific events are also shown, with the emperor being repeatedly present. The sequence begins at the bottom and then ascends in an anticlockwise spiral. The first scenes show the Roman frontier, with its military buildings and guards (I–II), then the departure of the Roman army from a well-fortified city and its crossing of the Danube on a pontoon bridge (III–IV; "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig33"
    }
  }, [_vm._v("Fig. 33")]), _vm._v("). Other scenes depict the advance into enemy territory (V); the emperor with his advisers (VI); a fortified Roman camp; sacrifice scenes (VIII); speeches (X), and construction (XI). These illustrate the routine of the war, but in addition, exceptional events are shown that may have been of particular importance for the campaign. Among these is the fall of a rider from his mule in the presence of Trajan (IX). Actual combat scenes are also given a lot of space. An example of this is Scene XXIV, probably intended to represent the Battle of Tapae (Cassius Dio 68.8) ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig34"
    }
  }, [_vm._v("Fig. 34")]), _vm._v("). If the general direction of reading is followed, the viewer first sees the result of the battle: two auxiliary soldiers present severed enemy heads to the emperor as a sign of their bravery and prowess. This is followed by the actual battle scene, with the Roman cavalry, legionary, and auxiliary troops. Their Dacian opponents are marked as barbarians by trousers, long beards, long tangled hair, and in part by their headgear; they operate out of the forest. The relentlessness of the struggle is illustrated by the well-known representation of a legionary who fights with the severed head of an enemy between his teeth,"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_39",
      "id": "ch1_39"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("39")])]), _vm._v(" but "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("also by the fact that there are no fleeing Dacians. Jupiter himself intervenes and fights on the side of the Romans. Among the gruesome aspects of war described in detail are the torching of Dacian houses, the deportation of women and children, the slaughter of domestic animals, and the execution of the men (XXIX/XXX). At the end of the first war, there is the submission of the Dacians in the presence of the emperor (LXXV) and a final speech by Trajan (LXXVII; "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig35"
    }
  }, [_vm._v("Fig. 35")]), _vm._v("). At the mid-point of the frieze, Victoria, the goddess of victory, appears between two "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("trophaia")]), _vm._v(", writing the victories of Trajan on a shield, and thus passing them on for posterity (LXXVIII). Then, with just as many scenes (77) and equally detailed, the second Dacian war is described, ending with the defeat and destruction of the Dacians and the suicide of their king, Decebalus (CXLV).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although the legibility of the reliefs may have been enhanced for the ancient viewer with paint and metal fittings, the continuous narrative of the reliefs on the column itself could not be followed."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_40",
      "id": "ch1_40"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("40")])]), _vm._v(" Only separate sections could be seen from the adjacent buildings, depicting the Roman army on the march, at sacrifices, or building fortifications and fighting. These details, even if they were only occasionally visible to the ancient viewer, suggest a high level of authenticity, validating the representations as accurate and realistic. It is fitting that mythological and allegorical characters are almost completely absent on the column and where they do occur, are set in their own context. Jupiter appears above the Battle of Tapae, clearly separated from the fighting soldiers (XXIV; see "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig34"
    }
  }, [_vm._v("Fig. 34")]), _vm._v("). Likewise, the writing Victoria is clearly separate from the narrative scenes (LXXVIII). River gods (III) and personifications of places (CL) are isolated from events by composition and size.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The illustrations are in part non-specific, such as sacrifices, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("adlocutiones")]), _vm._v(", and building scenes. Others, however, obviously signify important or spectacular events in the campaigns, such as the march across the pontoon bridge or the suicide of Decebalus. The strong stylization of the entire frieze is apparent by both wars being represented with the same number of scenes and of the same length. The emperor is represented 58 times and in different situations: as a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("togatus")]), _vm._v(", wearing a cuirass, or in civil service costume."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_41",
      "id": "ch1_41"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("41")])]), _vm._v(" He is always elevated in the composition and identifiable from his portrait. Again and again he gets involved, managing the army, speaking to the soldiers, or supervising construction and battles. The success of the army is down to him. Mostly he is found accompanied by advisers and experts, but it is him giving the instructions. Only a small number of scenes have stylistic precursors in the reliefs of the early Imperial period. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("adlocutio")]), _vm._v(" of the emperor has already been seen on the sesterces of Caligula ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig28"
    }
  }, [_vm._v("Fig. 28")]), _vm._v("); the image is extended and varied on Trajan’s Column. Similarly, the submission scene, shown at the end of the first Dacian war, was anticipated on the Augustus cup from Boscoreale ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig25"
    }
  }, [_vm._v("Fig. 25")]), _vm._v(") and sacrifices were common in Roman art from the Republican period onwards, and even more so in the early Imperial period. On Trajan’s Column, these images are integrated into a continuous sequence of events and thus convey a specific message.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The reliefs of Trajan’s Column depict precisely those elements of military events that the Augustan Boscoreale cup and Domitianic Cancelleria reliefs omitted. Conversely, events that are represented there are missing, namely the sacrifice upon departure and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("profectio")]), _vm._v(", the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("adventus")]), _vm._v(" and the triumphal parade of the emperor, which were rituals and ceremonies that took place in Rome itself. However, other monuments of Trajan’s time, such as the Arch of Beneventum,"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_42",
      "id": "ch1_42"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("42")])]), _vm._v(" definitely depict them, so they were still present as visual themes. What is new was that military campaigns were represented in Rome as a continuous narrative and in such detail that they seem to seamlessly document the emperor’s deeds in the field. The frieze thus appears to be a ‘visual paraphrase’ of literary accounts of the campaigns of Trajan."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_43",
      "id": "ch1_43"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("43")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0015-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig35"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 35")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig_caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 32–35")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rome, Trajan’s Column")])]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch01sec4_2"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Great Trajanic Frieze")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The new interest in the martial deeds of the emperor also informs another frieze, which probably comes from the Forum of Trajan, and thus must have been visible in the immediate vicinity of Trajan’s Column. Eight panels, which had been reused and installed in pairs in four different "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("places on the Arch of Constantine, as well as a series of fragments, can be used for a partial reconstruction."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_44",
      "id": "ch1_44"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("44")])]), _vm._v(" The main part shows the battle between the Romans and Dacians. The emperor plays a crucial role: at the head of his troops, he rides down the enemy and forces his opponents into flight ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig36"
    }
  }, [_vm._v("Fig. 36")]), _vm._v("). From the other side, the Roman cavalry have encircled and defeated the Dacians. Another scene from the battle is set on the left-hand side ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig37"
    }
  }, [_vm._v("Fig. 37")]), _vm._v("). It shows the return of the victorious emperor to Rome. The military context is illustrated by the fact that Trajan is wearing armour and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("paludamentum")]), _vm._v(", and that soldiers are accompanying him in the background. Victoria floats behind the emperor, crowning him, and thus distinguishing him as victor. Virtus leads him to an arch which symbolizes one of the gates of Rome. Some fragments belonging to the same frieze show soldiers standing quietly with standards; they may have belonged to a submission scene."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_45",
      "id": "ch1_45"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("45")])]), _vm._v(" The frieze thus originally contained three scenes relating to military events: the fight against the barbarians, decided by the emperor’s personal intervention; the return of the victorious general to Rome; and perhaps the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("submissio")]), _vm._v(" of the Dacians. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("adventus")]), _vm._v(" scene continued the conventions of the Domitianic Cancelleria relief by letting the emperor be seen with gods and personifications, thus enhancing a ceremony that actually took place in Rome. In contrast to them, the Great Trajanic Frieze connects these scenes with scenes of the actual war. However, the emperor appears here not as an organizer and leader of the campaign – as on Trajan’s Column – but as an heroic fighter.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig36"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 36")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig37"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 37")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig_caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 36–37")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rome, Arch of Constantine. Reused Trajanic frieze")])]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch01sec4_3"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Column of Marcus Aurelius")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("About three generations after the erection of Trajan’s Column, another Roman monument borrowed its shape, theme, and narrative form: the Column of Marcus Aurelius ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig38"
    }
  }, [_vm._v("Fig. 38")]), _vm._v("). On both columns, the campaign begins with the crossing of a river bridge over the Danube ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig39"
    }
  }, [_vm._v("Fig. 39")]), _vm._v("). The derivative nature of the column of Marcus Aurelius is also revealed in the structure of the reliefs, in the design of important scenes, and sometimes even in the reproduction of details. The first and most important message of Marcus Aurelius’ column is that he was as efficient, energetic, and successful a general as Trajan had been three generations earlier. His wars were as important for the Roman Empire as the Dacian wars and he mastered these challenges with the same energy and alertness as Trajan had done."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_46",
      "id": "ch1_46"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The exact dating of the column is controversial because the inscription associated with it has not come down to us. However, the representations refer to the campaigns of Marcus Aurelius against the Germans and Sarmatians in the years 172–5 and 178–80; the completion and dedication of the monument took place after his death."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_47",
      "id": "ch1_47"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("47")])]), _vm._v(" In the 116 scenes, Marcus Aurelius himself appears 59 times. Scene III,"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_48",
      "id": "ch1_48"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("48")])]), _vm._v(" for instance, shows the emperor leading the Roman army over the Danube. In the following scenes, he is always talking to the soldiers, as at the end of the first campaign, where he reads out a proclamation."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_49",
      "id": "ch1_49"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("49")])]), _vm._v(" In other scenes he is negotiating with barbarians; sacrificing; monitoring the advance of the Roman troops; directing the fighting; judging prisoners ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig40"
    }
  }, [_vm._v("Fig. 40")]), _vm._v("); watching the removal of booty and prisoners; accepting the submission of the barbarians; and negotiating contracts. All of these depictions make it clear that the emperor personally directs all phases of the campaigns and thereby tirelessly and diligently takes care of all the crucial questions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Compared to Trajan’s Column, the changes are mainly on a formal level initially: the visibility of the individual figures and the legibility of the scenes has been improved on the Marcus Column by reducing the number of turns; the figures therefore are larger and also presented more clearly. Stylistically, the reliefs are less classical, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("i.e.")]), _vm._v(" the figures move in a livelier manner, and they are pictured more dramatically and expressively; the whole relief is more influenced by effects of light and shadow."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_50",
      "id": "ch1_50"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("50")])]), _vm._v(" However, there are also differences in detail: the construction scenes that are presented so impressively on Trajan’s Column are largely missing on the Marcus Column; on the other hand, scenes of combat as well as of killing and destruction are more common: the brutality of war against the defeated barbarians is also clearer, just because of the legibility of the images."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_51",
      "id": "ch1_51"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("51")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig38"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 38")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig39"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 39")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig40"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 40")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig_caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 38–40")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rome, Marcus Column")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch01sec4_4"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A series of reliefs of Marcus Aurelius")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The military campaigns of Marcus Aurelius were also the subject of the reliefs on an honorific arch, eight of which were later installed in pairs on the Arch of Constantine; three more were brought to the Capitol in the 16th century, from the church of S. Martina. These eleven reliefs belong to a series and probably decorated a monumental arch to Marcus Aurelius."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_52",
      "id": "ch1_52"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("52")])]), _vm._v(" The sequence of events begins with the emperor embarking upon a campaign and departing from Rome ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig41"
    }
  }, [_vm._v("Fig. 41")]), _vm._v("). The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("genius")]), _vm._v(" of the Senate and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("genius")]), _vm._v(" of the Roman people, who stand behind him and remain within the urban area, are bidding the emperor farewell. This is followed by several events from the campaign, an example being a speech of the emperor to his soldiers. Another relief shows an incense offering, which the emperor takes in his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("toga")]), _vm._v(" at a portable metal altar. We also know this scene from Trajan’s Column, where it is clear that a procession of soldiers is walking around a fortified camp. The sacrifice is therefore a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lustratio")]), _vm._v(", the ritual purification of the army, carried out by the commander in accordance with his obligations. The success of the commander is manifested in the subjugation of the barbarians. One such relief shows two men who fall to their knees before the mounted emperor and plead with outstretched hands, asking for mercy ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig42"
    }
  }, [_vm._v("Fig. 42")]), _vm._v("). Other enemies are captured by Roman soldiers and led, bound, to the general. The campaign depicts scenes including the establishment of a client king.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sequence of the six scenes of war is unclear. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("adlocutio")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lustratio")]), _vm._v(" are standard narrative scenes in war and can therefore be inserted at any point. The establishment of the vassal king is more likely to belong to the end. But what happens next is then clear: after the successful completion of the campaign, the emperor returns to Rome in travelling clothes, accompanied by Mars and Virtus ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig43"
    }
  }, [_vm._v("Fig. 43")]), _vm._v("). In the background, a monumental arch is visible next to the Temple of Fortuna Redux. The goddess Fortuna herself is in the background next to her temple. Beside her appears Felicitas, holding a cornucopia and a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("caduceus")]), _vm._v(", and thereby referring to the prosperity that the return of the emperor brings. Above the emperor hovers the victory goddess, Victoria, making it clear that he returns victorious. Then the depiction of a triumph follows ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig44"
    }
  }, [_vm._v("Fig. 44")]), _vm._v("). The triumphant emperor drives through the city in the richly decorated triumphal "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quadriga")]), _vm._v(". Above the emperor, the goddess Victoria is still hovering. A "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tuba")]), _vm._v(" player and a single lictor lead the way. The strangely cramped pose of Marcus Aurelius is explained by the fact that, originally, a second figure was riding in the emperor’s chariot: Commodus, who was later, after his fall and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("damnatio memoriae")]), _vm._v(", removed. The destination of the triumphal procession was the Capitol, where the victor was offering a sacrifice to Jupiter Optimus Maximus. Beside the emperor is the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("flamen dialis")]), _vm._v(", the priest responsible for the cult of Jupiter. Behind the emperor appears the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("genius")]), _vm._v(" of the Senate. This sacrifice can be located precisely because it takes place in front of the temple of Jupiter Optimus Maximus, the three doors visible on the relief referring to the three "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cellae")]), _vm._v(" of the Capitoline Triad. Jupiter, Juno, and Minerva are also seen in multiple figures on the pediment of the temple. The final relief shows the distribution of largesse by the emperor. On a high pedestal, Marcus Aurelius is seated on a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sella curulis")]), _vm._v(" in a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("toga")]), _vm._v(". He is surrounded by togate men and on the instructions of the emperor, an assistant distributes the money to the men, women, and children who have lined up in front of the podium. Again, a figure seated on a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sella curulis")]), _vm._v(" next to the emperor (and therefore his equal) has subsequently been removed: it can only have been Commodus.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0018-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig41"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 41")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rome, Arch of Constantine. Reused relief from an arch of Marcus Aurelius")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig42"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 42")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig43"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 43")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig44"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 44")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig_caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 42–44")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reliefs from an arch of Marcus Aurelius; "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig43"
    }
  }, [_vm._v("Fig. 43")]), _vm._v(" reused in the Arch of Constantine; "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig42"
    }
  }, [_vm._v("Figs 42")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig44"
    }
  }, [_vm._v("44")]), _vm._v(" Rome, Capitoline Museums")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A comparison of this series of reliefs with the Marcus Column shows that both represent the same topic, but with a different focus. While the column is limited entirely to the events of war far from Rome and attempts to describe them in detail, the reliefs emphasize the connection with the city: the emperor leaves Rome and returns there after the end of the war; he celebrates a triumph there and brings Jupiter a victory sacrifice; and finally he endows the city population with a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("congiarium")]), _vm._v(". The events in Rome are precisely located, and thus based on very specific and verifiable occasions. Unlike the column, the close relationship between the emperor and the Senate is important: in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("profectio")]), _vm._v(", as in the victory sacrifice, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("genius senatus")]), _vm._v(" is close to the emperor. However, the emperor’s relationship with the traditional priesthoods, the population, and even the gods of Rome themselves is also depicted as close and harmonious. Finally the dynastic aspect was emphasized by the fact that his son Commodus appears at the side of Marcus Aurelius in two reliefs. In this manner, the reliefs blend the specific events of war into a few standardized situations. As with the column, so in the portrayal on the relief – whatever the emperor does is perfect, both "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("domi et militiae")]), _vm._v(", in Rome and on campaign.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch01sec4_5"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Arch of Severus")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The monumental arch of Septimius Severus and his sons in the Roman Forum"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_53",
      "id": "ch1_53"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("53")])]), _vm._v(" was established by resolution of the Senate and consecrated between 10th December 202 and 9th December 203 ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig45"
    }
  }, [_vm._v("Fig. 45")]), _vm._v("). According to the inscription, the reason was the restoration of the state, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("i.e.")]), _vm._v(" the end of the civil wars, as well as the expansion of the empire. The campaigns of the years AD 197–9 against the Parthians are depicted in four relief panels, which are mounted on both faces over the side passages and together comprise 74 m"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("2")]), _vm._v(". Of the twelve scenes, three show sieges and another three the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("adlocutio")]), _vm._v(" of the emperor. On each panel, two city views occur. If one begins by examining the left field of the relief panel facing the Forum, then three superimposed set scenes can be distinguished: below is the departure of the Roman army from a city, probably Nisibis; above, a battle, and at the top, an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("adlocutio")]), _vm._v(" and a city view. The second panel, right next to it, in fact shows five scenes, which in turn are arranged into three strips, one above the other: below, the storming of a city with a large battering ram; to the right, the subjugation of the barbarians in front of the emperor and, to the left, an address by the emperor; and in the top right, the arrival of the emperor in a city (probably Edessa) and, top left, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("profectio")]), _vm._v(", the departure of the army. On the side of the arch facing the Capitol, the relief shows (bottom left) the siege of a city by a river, probably Seleucia,"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_54",
      "id": "ch1_54"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("54")])]), _vm._v(" and the surrender of the city ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig46"
    }
  }, [_vm._v("Fig. 46")]), _vm._v("). The fourth panel (below) is the siege of Ctesiphon on the Tigris, and (above) another "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("adlocutio")]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig47"
    }
  }, [_vm._v("Fig. 47")]), _vm._v("). Among the total of 484 figures in the campaign scenes, the emperor appears eight times. While the figures are usually presented in dense groups, the occurrence of the emperor is significant: he is always shown from the front, placed in front of the crowded group of companions, and is the one person shown with no overlap. Similar observations can be made on the Marcus Column, where the importance of the emperor is consistently emphasized in the same manner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The representations are partly stereotypical, for instance the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("adlocutio")]), _vm._v(" scenes, so that they can be read not only as an event in the course of the campaign, but also as a general expression of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fides militum erga imperatorem")]), _vm._v(". Like the reliefs on Trajan’s Column, the scenes include landscape elements and thereby appear scenic. According to Herodian (III.9.12), Severus had paintings erected in public in Rome with the struggles and victories of his Parthian War. The reliefs of the arch could hark back to these historical paintings. However, the similarity with the representations on the columns and especially with the Column of Marcus Aurelius is striking, manifested in the use of the same types of scenes ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("e.g.")]), _vm._v(" the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("adlocutio")]), _vm._v(" scenes), the division into registers, and the progression of the story from the bottom up. The relief areas of the arch look like cut-out and framed parts of the column reliefs.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0020-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig45"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 45")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("They were obviously inspired by the detail- and figure-rich representation on the columns. However, the Arch of Severus fixes the viewpoint and selects the images, while with the columns, the viewer makes that selection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The reliefs described, which should reflect key events of a historical campaign, are integrated into the overall programme of the sculptural decoration of the arch. Immediately above the side passages, and therefore below the great campaign reliefs, a booty frieze is shown repeated four times ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig46"
    }
  }, [_vm._v("Fig. 46")]), _vm._v("): Roman soldiers lead a train of wagons laden with booty, also carrying captive Easterners. In the middle of the display sits a grieving woman with an oriental cap personifying the conquered Eastern territories (Parthia). This train leads to the city goddess Roma, enthroned upon arms; before her, Easterners drop to their knees. Earlier monumental arches (the Arch of Titus in Rome, the Arch of Trajan in Beneventum) have small friezes with detailed representations of a triumphal procession. Although the frieze on the Arch of Severus contains triumphal elements, it does not represent the triumph itself. In particular, it lacks the victor as the main character of the procession. The reason for this choice of representation is that Septimius Severus had rejected a triumph ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Historia Augusta")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Severus")]), _vm._v(" 16.6). The small frieze mixed two different areas: the booty train can be understood as a depiction of actual operations, but is combined with two personifications, the grieving Parthia and the victorious Roma. The fourfold repetition shows that it is not a one-off event; rather, imperial victory also repeatedly produces material gains. The reliefs of the column base tackle the military issue by presenting captive Parthians and Roman soldiers. The victories above the main passage carry "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("trophaia")]), _vm._v(" from the Parthian campaign.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The large relief panels depict the foreign policy successes of Severus in great detail and as a continuous narrative. At the same time they ignore the struggles of the civil wars, alluded to in the inscription. The issue of military successes is taken up again in other forms in other areas: in the small frieze with its emphasis on booty given to Roma; in the reliefs of the column base with their depictions of defeated Easterners and victorious Romans; and in the attic reliefs over the main passage with their depictions of the goddess of victory.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig46"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 46")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig47"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 47")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig_caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 45–47")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rome, Roman Forum. Arch of Septimius Severus")])]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section",
    attrs: {
      "id": "ch01sec5"
    }
  }, [_c('span', {
    staticClass: "num_hangs"
  }, [_vm._v("5")]), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Representations from the Tetrarchic period")])]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch01sec5_1"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Arch of Galerius in Thessaloniki")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Of the tetrapylon, which was built around AD 300 in Thessaloniki, then the residence of Emperor Galerius, two of the four pylons (with a total of 28 reliefs) remain."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_55",
      "id": "ch1_55"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("55")])]), _vm._v(" The "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("subject of the reliefs is Gallienus’ war against the Sassanids in AD 297/8. The war concluded in 298 with a peace treaty, which ceded northern Mesopotamia and the five provinces beyond the Tigris to the Romans.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig48"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 48")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig49"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 49")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig50"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 50")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-04.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig51"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 51")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig_caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 48–51")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thessaloniki, Arch of Galerius")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most images promote Galerius as a successful commander. Some of the subjects are quite conventional: travel ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig48"
    }
  }, [_vm._v("Fig. 48")]), _vm._v("), speeches ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig49"
    }
  }, [_vm._v("Fig. 49")]), _vm._v("), battles ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig50"
    }
  }, [_vm._v("Fig. 50")]), _vm._v("), prisoners, and the allegorical exaltation of the emperor. The images presented could also have been used for any previous emperor: Trajan and Septimius Severus had themselves depicted in Parthian campaigns in almost the same scenes. By contrast, some representations are located by inscriptions and thus identified as certain events in the campaign. Thus, the river god adjacent to a fight scene is labelled Tigris (AI Scene 3; similar to A II 5). Others show spectacular successes of the campaign of 297/8, for example the capture of the royal harem (AI 2). One of the battle scenes (B II 20) illustrates the courage and vigour of the emperor, which decide the fight ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig50"
    }
  }, [_vm._v("Fig. 50")]), _vm._v("). The emperor appears on horseback in the centre of the depiction; he is striking down both an enemy horseman and an infantryman, regardless of personal risk. The eagle of Jupiter holds a wreath over Galerius’ head and marks him as victor. Three colossal Roman soldiers represent the power of the Roman army, contrasting conspicuously with the small Persians. A similarly drastically unequal distribution of power is demonstrated in the subjugation scene (A III 9) and in the envoy scene (BI 16) ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig51"
    }
  }, [_vm._v("Fig. 51")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Arch of Galerius differs from earlier representations of war in the scenes relating to the Tetrarchy, the form of government then newly created by Diocletian. This includes the victory sacrifice, which is offered jointly by Diocletian and Galerius (BI 17; "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig51"
    }
  }, [_vm._v("Fig. 51")]), _vm._v(" below). The historic "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("campaign of Galerius, which most reliefs on the arch strive to depict accurately, is integrated into the ‘success story’ of the Tetrarchy in a further relief (II 19 B), but in a stylized manner. In the centre of this relief, the two Augusti, Diocletian and Maximianus Herculius, sit on a globe, both being crowned by Victoria. Next to them are the Caesars, Galerius and Constantius Chlorus, both of whom raise up a kneeling province. The duplication of events is noteworthy: it occurs simultaneously and in the same manner to the left and right of the enthroned Augusti; Mesopotamia is shown in the east of the empire and Britannia in the west. The Augusti themselves do not need to intervene here, as their watchful presence is enough to guarantee Roman success. The imperial group is flanked by gods and personifications.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The series of reliefs on the arch in Thessaloniki is intended to convey to the viewer that they live in an ideal world: with the help of the gods, the tetrarchy brings stability and victories, which in turn delivers material well-being. This happy state of affairs will last forever, because the system of the Tetrarchy will renew itself periodically. The realism of the depictions is validated by specific references – the labels locating the battle sites and the representation of unique events, such as the capture of the Sassanid harem. Because these events are verifiable and authenticated by the details pictured, this suggests to the viewer that, if the representation is exact in these details, it must also be correct elsewhere.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section",
    attrs: {
      "id": "ch01sec6"
    }
  }, [_c('span', {
    staticClass: "num_hangs"
  }, [_vm._v("6")]), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Representations from Late Antiquity")])]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch01sec6_1"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Arch of Constantine")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("In the struggle against his rival Maxentius in AD 312, Constantine, son of the Tetrarchic Emperor Constantius Chlorus, had brought cities in Gaul and northern Italy over to his side, partly by conquest, partly won peacefully. After advancing on Rome, the decisive battle, in which Maxentius was killed, took place at the Milvian Bridge on 28 October 312. The very next day, Rome was taken by Constantine. These events were commemorated in the reliefs and the inscription on the arch, which the Senate had erected for Constantine next to the Colosseum."), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#rch1_56",
      "id": "ch1_56"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("56")])]), _vm._v(" This also used older reliefs as spolia, including parts of the battle from the Great Trajanic Frieze and reliefs from an arch of Marcus Aurelius.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The small frieze attached to the front, above the side passages and (at the same height) on the shorter sides of the arch is of Constantinian date and relates events of the campaign against Maxentius. The illustrations are arranged chronologically, beginning on the smaller western side. First, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("profectio")]), _vm._v(" is shown, the departure of the army from Milan ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig52"
    }
  }, [_vm._v("Fig. 52")]), _vm._v("). The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cornicines")]), _vm._v(" (horn players) and standard bearers lead the way. Some of the following soldiers are shown as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cornuti")]), _vm._v(" with horned helmets, members of an elite Gallic force. Behind the combat troops follows the train with a camel and a horse; at the rear is a cart with two officers. The relief shows a well-ordered, disciplined army, equipped with all the necessities and arrayed in marching order. On the south side of the arch, facing away from the town, the conquest of Verona ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig53"
    }
  }, [_vm._v("Fig. 53")]), _vm._v(") is presented. In the right part, the city with its towers is shown, one of the defenders collapsing, mortally wounded, from the wall. The troops of Constantine are placed to the left of this scene. Behind them stands Constantine, emphasized by his size, in muscle cuirass and wearing a cloak. Following him are the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("protectores")]), _vm._v(" (bodyguard) and, on the extreme left, his caparisoned horse. Victoria flies in to crown Constantine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The right-hand relief on the south side shows the Battle of the Milvian Bridge ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig54"
    }
  }, [_vm._v("Fig. 54")]), _vm._v("). In the centre, the dramatic and decisive moments of the conflict can be seen: the Praetorians of Maxentius sink into the water and are fought from the shore by the troops of Constantine. To the right are a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cornicen")]), _vm._v(" and a trumpeter; to the left, on the approach of the bridge destroyed by Maxentius, Constantine is shown, accompanied by Victoria and Virtus. The two reliefs show the army in action; fighting under the guidance of the emperor himself, his soldiers are orderly, disciplined, and effective.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the eastern, narrow side, the entry into Rome follows, which took place on 29 October 312 ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig55"
    }
  }, [_vm._v("Fig. 55")]), _vm._v("). The victorious emperor’s team of four is driven by Victoria. First are the infantry, followed by cavalrymen with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("draco")]), _vm._v(" standards, then more foot soldiers. The entire army is again well equipped and disciplined. The front and back of the column are marked by an arch, so the army is already marching within the city.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the north side, facing the city, the reliefs show the appearance of Constantine in Rome. The first depicts the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("oratio")]), _vm._v(", his address to the people of Rome. Events are accurately located by the buildings in the background: we can still identify the exact spot where Constantine was standing. The emperor is meeting with the senators in the Roman Forum, in the old traditional capital in the heart of the empire, and he speaks to the people of Rome. This relief shows their close ties with Constantine. This appears as a contrast to the tyrant Maxentius, who allegedly murdered senators and massacred the people. The topographic accuracy guarantees the exact reproduction of the activities and confirms the entire process. The last relief in this cycle shows the distribution of gifts of money and records the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("largitas Augusti")]), _vm._v(", the liberality of the emperor. Again, the emperor is seated in the centre, flanked by two strictly symmetrically arranged groups. These illustrate the distribution of money in four accounting offices. It takes place in an organized, controlled way: two senators each keep the books and vouch for the orderly course of events.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0024-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig52"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 52")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0024-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig53"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 53")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig54"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 54")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captiond",
    attrs: {
      "id": "fig55"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 55")])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig52a"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures 52–55 Rome, Arch of Constantine")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The six reliefs described form a coherent, self-contained story: the army departs from Milan; it besieges Verona under the guidance of its victorious Emperor Constantine; it defeats the troops of the tyrant on the Tiber with his guidance and moves into Rome; Constantine speaks to the Roman Senate and people of Rome in the Forum; and he enters the consulship in Rome, distributing generous donations on this occasion. The military successes of Constantine thus lead to a happy, harmonious agreement between the emperor, the Senate, and the people. The two military depictions can be found next to each other on the southern side, or in other words on the side facing away from the city centre. Both images show how the emperor commands his soldiers and in both he is accompanied by Victoria. On the north side, facing the centre of the city and placed side by side, are the two reliefs showing the emperor in Rome itself. In those, the military is almost completely absent; they demonstrate the harmonious relationship between the emperor and the Senate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The remaining reliefs of the arch, including the reused reliefs, confirm this statement. Within the main passage of the arch, two battle panels from the Great Trajanic Frieze decorate the western wall on the left; they are related by their inscription ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Liberatori urbis’")]), _vm._v(" to the victory over Maxentius ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig36"
    }
  }, [_vm._v("Fig. 36")]), _vm._v("). The head of the main figure was reworked into a portrait of Constantine. The observer sees Constantine, who single-handedly rides down barbaric foes, while the context of the inscription makes it clear that these must be the soldiers of Maxentius. The relief does not show Praetorians and Romans as the opponents, but barbarians: the liberation "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("of the city from Maxentius does not appear as a success in the civil war, but as a victory over external enemies. Two more panels from the Great Trajanic Frieze are mounted on the eastern wall and provided with the explanatory inscription ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fundatori Quietis’")]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#fig37"
    }
  }, [_vm._v("Fig. 37")]), _vm._v("). The observer sees two scenes: to the left, the emperor, who is led by soldiers, but also by Virtus and Honos, to a gate and simultaneously crowned by Victoria; and to the right a combat scene is again included. The reliefs originally celebrated the victory of Trajan over the Dacians; after the replacement of the head of the emperor, they became depictions of the victories of Constantine. The front sides of the arch’s attic are decorated with reliefs, which were also re-used and taken from an arch of Marcus Aurelius.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to the reliefs showing the emperor himself, the arch also has decorative imagery that is more generic. The reliefs of the column bases, for example, mix four themes: victories, soldiers with standards, prisoners next to a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("trophaion")]), _vm._v(", and captive barbarians, who are being led away by Roman soldiers. These themes are not new, nor is their representations on the column bases: they are already found, for example, on the Arch of Severus. What is surprising about the representations is seeing them in context with the inscription, because it does not mention victories over barbarous peoples. So these are generic images that do not refer to a single specific campaign, but celebrate the universal victory of the Roman army, as do the reliefs with victories above the main passage. Looking at the Arch of Constantine as a whole, the large-scale reliefs are dominated by representations of the emperor. Again and again, the emperor appears in a beneficial capacity, which is in part military, and in part civil. On the Arch of Constantine, these depictions are not meant to represent one-off events; rather, they illustrate the virtues of the emperor in typical situations. They are supplemented by more general scenes on the base and spandrel reliefs. Representations of the emperor are missing here, but the depictions point to his universal and permanent victory. The attentive Roman observer knew these symbolic depictions from older monuments and understood that the emperor here asserted virtues that had already been claimed by previous emperors such as Trajan and Severus. That these were not empty promises or even pretence, was vouched for by the series of historical reliefs: they show the efficient and disciplined army of Constantine, his work as a successful general, and his close and trusting relationship with the old capital, Rome. As with the Arch of Galerius, the promise of universal happiness in the relief decoration is validated by referring to concrete actions and successes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The small historical friezes show the emperor as one figure among many, albeit emphasized by size and composition. However, the reused attic reliefs focus more on the figure of the emperor and his immediate companions. The same theme appears several times in different parts of the decorative reliefs. The military activities of the emperor are shown in the context of historical events, as head of his army, but then as a courageous fighter against the enemies of Rome in the recycled Trajanic reliefs in the passage, with the explanation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Liberatori Urbis")]), _vm._v(". The emperor appears repeatedly in the company of Victoria and Virtus; bravery and victory are closely associated with him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A second theme that is used in various forms in the relief decoration of the Arch of Constantine is the close relation of the emperor with Rome. It is shown in three series of reliefs, and, like the emperor’s victory, in several different manners. The small friezes clearly show events in Rome, and the appearances of Constantine in Rome are also located precisely in the attic reliefs and in the passage reliefs. But there he is not shown in front of the citizens and senators of Rome, but in the company of gods and personifications. Particularly important is the arrival of the emperor ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("adventus")]), _vm._v(") in Rome, which is shown three times. The distribution of money to the Roman city population is illustrated twice, namely in the Attic reliefs and as a conclusion to the small historical friezes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This idealized emperor is to be seen against the background of the defeated predecessor, whom the sources paint in the darkest colours. Constantine appears in all respects as the exact opposite of the tyrant: he is brave and victorious, generous, and in harmony with the Senate and people. His dominion is fully legitimized by his virtues, as well as through his lineage and his visual referrals to the good emperors of the 2nd century AD. As with the Arch of Galerius, these depictions reflect an idealized image, a relationship that did not last, and a hope of the Senate, which was not realized. In January 313, Constantine left Rome and then only returned for anniversaries of his accession.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_sectiona",
    attrs: {
      "id": "ch01sec7"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Notes to Part I")])]), _vm._v(" "), _c('p', {
    staticClass: "note_listd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_1",
      "id": "rch1_1"
    }
  }, [_c('span', {
    staticClass: "note_hangd"
  }, [_vm._v("1.")])]), _vm._v(" Cf. Bauchhenß 1978; Tufi 1988; Pflug 1989, 96f;. Boppert 1992; von Moock 1998, 59f.")]), _vm._v(" "), _c('p', {
    staticClass: "note_listd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_2",
      "id": "rch1_2"
    }
  }, [_c('span', {
    staticClass: "note_hangd"
  }, [_vm._v("2.")])]), _vm._v(" Homolle 1897, 620ff.; 1903, 297–302.")]), _vm._v(" "), _c('p', {
    staticClass: "note_listd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_3",
      "id": "rch1_3"
    }
  }, [_c('span', {
    staticClass: "note_hangd"
  }, [_vm._v("3.")])]), _vm._v(" Cf. Jacquemin 1999, No. 424; Kotsidu 2000, 443 ff. Cat. No. *318; Boschung 2001, 59–72; E. Schraudolph in Bol 2007, 231–4. 401 Abb. 194a–h.")]), _vm._v(" "), _c('p', {
    staticClass: "note_listd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_4",
      "id": "rch1_4"
    }
  }, [_c('span', {
    staticClass: "note_hangd"
  }, [_vm._v("4.")])]), _vm._v(" Plutarch, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aemilius Paullus")]), _vm._v(" 28.2; Kotsidou 2000, 445.")]), _vm._v(" "), _c('p', {
    staticClass: "note_listd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_5",
      "id": "rch1_5"
    }
  }, [_c('span', {
    staticClass: "note_hangd"
  }, [_vm._v("5.")])]), _vm._v(" Hammond 1984, 31–47.")]), _vm._v(" "), _c('p', {
    staticClass: "note_listd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_6",
      "id": "rch1_6"
    }
  }, [_c('span', {
    staticClass: "note_hangd"
  }, [_vm._v("6.")])]), _vm._v(" Homolle 1897, 621; Kähler 1965, 12f.; von Vacano 1988, 375.")]), _vm._v(" "), _c('p', {
    staticClass: "note_listd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_7",
      "id": "rch1_7"
    }
  }, [_c('span', {
    staticClass: "note_hangd"
  }, [_vm._v("7.")])]), _vm._v(" Boschung 2001, 65.")]), _vm._v(" "), _c('p', {
    staticClass: "note_listd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_8",
      "id": "rch1_8"
    }
  }, [_c('span', {
    staticClass: "note_hangd"
  }, [_vm._v("8.")])]), _vm._v(" von Vacano 1988, 375; Kähler 1965, 13.")]), _vm._v(" "), _c('p', {
    staticClass: "note_listd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_9",
      "id": "rch1_9"
    }
  }, [_c('span', {
    staticClass: "note_hangd"
  }, [_vm._v("9.")])]), _vm._v(" Boschung 2001, 67.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_10",
      "id": "rch1_10"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("10.")])]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_11",
      "id": "rch1_11"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("11.")])]), _vm._v(" Vierneisel-Schlörb 1979, 472ff. No. 43; Geominy 1982, esp. 147ff.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_12",
      "id": "rch1_12"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("12.")])]), _vm._v(" Eichberg 1987, 157ff.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_13",
      "id": "rch1_13"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("13.")])]), _vm._v(" Ibid., 188f., 284f. Nos 238–42.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_14",
      "id": "rch1_14"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("14.")])]), _vm._v(" Hammond 1984, 46.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_15",
      "id": "rch1_15"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("15.")])]), _vm._v(" Ibid., 44.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_16",
      "id": "rch1_16"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("16.")])]), _vm._v(" On the arrangement, cf. Jacquemin-Laroche 1982, 212.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_17",
      "id": "rch1_17"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("17.")])]), _vm._v(" Kähler 1966; Hölscher 1979, 337ff.; Torelli 1982, 5ff. Taf. I,1–4.; Hölscher 1984a, 16ff.; Zanker 1987, 22ff.; Meyer 1993, 45ff.; Fless 1995, 31ff. 103 Cat. No. 2; Lohmann 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_18",
      "id": "rch1_18"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("18.")])]), _vm._v(" Wünsche 2005, 120f.; M. Flashar, in Bol 2007, 371f., 420 Abb. 370a–f.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_19",
      "id": "rch1_19"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("19.")])]), _vm._v(" Hölscher 1980b, 351ff., 1984a, 17ff., 1988, 384ff. No. 214; Schäfer 1979, 243ff., 1989, 74ff.; Meyer 1991/92, 17ff.; Reusser 1993, 121ff.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_20",
      "id": "rch1_20"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("20.")])]), _vm._v(" Polito 1998, 91–95.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_21",
      "id": "rch1_21"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("21.")])]), _vm._v(" Miller 1993, 48–59 Taf. 2–3; Polito 1998, esp. 74ff. with further examples.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_22",
      "id": "rch1_22"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("22.")])]), _vm._v(" Hölscher 1980b; 1988, 384ff.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_23",
      "id": "rch1_23"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("23.")])]), _vm._v(" Reusser 1993, 135ff.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_24",
      "id": "rch1_24"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("24.")])]), _vm._v(" Hölscher 1984b, 204ff.; Leoncini 1987, 13ff., 58ff.; Zanker 1987, 130ff.; Hölscher 1988, 364ff. No. 200; Boschung 1999, 202f. Abb. 1.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_25",
      "id": "rch1_25"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("25.")])]), _vm._v(" Siebert 1999, 161–289 F1.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_26",
      "id": "rch1_26"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("26.")])]), _vm._v(" Zanker 1987, 130f.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_27",
      "id": "rch1_27"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("27.")])]), _vm._v(" Hölscher 1980a, 281ff.; Baratte 1986; Kuttner 1995; Boschung 1999, 203f. Abb. 2–5; Alföldi 2001; de Caprariis 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_28",
      "id": "rch1_28"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("28.")])]), _vm._v(" Cf. Orlin 2002, 38–45.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_29",
      "id": "rch1_29"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("29.")])]), _vm._v(" In my opinion incorrectly disputed by de Caprariis 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_30",
      "id": "rch1_30"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("30.")])]), _vm._v(" Kähler 1968; Megow 1987, 155f. A 10 Taf. 3–6; Prückner 1997, 119ff.; Zwierlein-Diehl 2008, 98ff. Nr. 6.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_31",
      "id": "rch1_31"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("31.")])]), _vm._v(" Künzl 1988, 558f. No. 383; Zanker 1987, 234f. Abb. 183.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_32",
      "id": "rch1_32"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("32.")])]), _vm._v(" Megow 1987, 202 A 85; Boschung 1989, 64f.; Vollenweider-Avisseau 2003, 219ff. No. 275 Taf. 27–31; Giulani 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_33",
      "id": "rch1_33"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("33.")])]), _vm._v(" Kent-Overbeck-Stylow 1973, 99 Taf. 46. 47 No. 172. 176; von Kaenel 1986, 7. 10ff. 46ff. 67ff. 162f. Taf. 1. 6ff. Nos 2–44, 430–46, 458–531, 577–90; Boschung 1987, 224.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_34",
      "id": "rch1_34"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("34.")])]), _vm._v(" Stäcker 2003, 169ff.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_35",
      "id": "rch1_35"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("35.")])]), _vm._v(" Frieze A: Magi 1945; Bergmann 1981, 19ff.; Simon 1985, 543ff.; Hölscher 1992; Meyer 2000, 124–139; Hölscher 2009, 54–8.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_36",
      "id": "rch1_36"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("36.")])]), _vm._v(" Boschung 2004, 103f.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_37",
      "id": "rch1_37"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("37.")])]), _vm._v(" Eibl 1994, 273–97.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_38",
      "id": "rch1_38"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("38.")])]), _vm._v(" Cichorius 1896–1900; Lehmann-Hartleben 1926; Zanker 1970, 529ff.; Gauer 1977; Hölscher 1980a, 290ff.; Settis "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("et al.")]), _vm._v(" 1988; Baumer-Hölscher-Winkler, 1991, 261ff.; Krierer 1995, 123ff.; Galinier 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_39",
      "id": "rch1_39"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("39.")])]), _vm._v(" Krierer 1995, 128.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_40",
      "id": "rch1_40"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("40.")])]), _vm._v(" Galinier 2007, 158–61.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_41",
      "id": "rch1_41"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("41.")])]), _vm._v(" Ibid., 59 Abb. 15, 63ff.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_42",
      "id": "rch1_42"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("42.")])]), _vm._v(" Fittschen 1972, 742ff.; Simon 1981, 3ff.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_43",
      "id": "rch1_43"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("43.")])]), _vm._v(" Zanker 1970, 727.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_44",
      "id": "rch1_44"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("44.")])]), _vm._v(" Leander Touati 1987; Galinier 2007, 185ff.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_45",
      "id": "rch1_45"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("45.")])]), _vm._v(" Leander Touati 1987, 98ff., esp. 103.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_46",
      "id": "rch1_46"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("46.")])]), _vm._v(" Hölscher 2000, 89.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_47",
      "id": "rch1_47"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("47.")])]), _vm._v(" Coarelli 2008, 32–7; Löhr 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_48",
      "id": "rch1_48"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("48.")])]), _vm._v(" Petersen "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("et al.")]), _vm._v(" 1896 Taf. 9–11; Coarelli 2008, 114–18.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_49",
      "id": "rch1_49"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("49.")])]), _vm._v(" Petersen "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("et al.")]), _vm._v(" 1896 Taf. 63; Coarelli 2008, 222ff.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_50",
      "id": "rch1_50"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("50.")])]), _vm._v(" Pirson 1996, bes. 168–71.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_51",
      "id": "rch1_51"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("51.")])]), _vm._v(" Ibid., 139–79.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_52",
      "id": "rch1_52"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("52.")])]), _vm._v(" Ryberg 1967; Koeppel 1986; Angelicoussis 1984; De Maria 1988, 303ff.; Torelli 1993, 98f.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_53",
      "id": "rch1_53"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("53.")])]), _vm._v(" Koeppel 1990, 1ff. 9ff.; Brilliant 1967; De Maria 1988, 305ff.; Krierer 1995, 165f., 218.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_54",
      "id": "rch1_54"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("54.")])]), _vm._v(" Brilliant 1967, 195ff.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_55",
      "id": "rch1_55"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("55.")])]), _vm._v(" Laubscher 1975; Kolb 2001, 158–62; Mayer 2002, 47–65; Boschung 2006, 360–7.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01#ch1_56",
      "id": "rch1_56"
    }
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_vm._v("56.")])]), _vm._v(" L’Orange-Gerkan 1955; De Maria 1988, 316–19; Pensabene-Panella 1999; Mayer 2002, 185ff.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17150599","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Part01.vue
// module id = 78
// module chunks = 0